import { createContext } from 'react';

import type { FeatureFlagKey, FeatureFlagsContextType } from './types';

export type { FeatureFlagKey, FeatureFlagsContextType };

// ----------------------------------------------------------------------

export const FeatureFlagsContext = createContext<FeatureFlagsContextType>({
  flags: {},
  loading: false,
  error: null,
  refresh: () => {},
});
